import { StoredCheckin, checkinTags } from "../lib/checkin";

/** How the athlete said they were going in to a session, as three coloured tags. */
export function CheckinTags({ checkin }: { checkin: StoredCheckin | null | undefined }) {
  if (!checkin) return null;
  return (
    <div className="checkin-tags">
      <span className="eyebrow">Check-in</span>
      {checkinTags(checkin).map((tag) => (
        <span key={tag.text} className={`badge checkin-tag tone-${tag.tone}`}>
          {tag.text}
        </span>
      ))}
      {checkin.pain_note && <span className="element-notes">&ldquo;{checkin.pain_note}&rdquo;</span>}
    </div>
  );
}
